import { defineStore } from 'pinia';

export type TVideoMode = 'inline' | 'pictureinpicture' | 'fullscreen';

interface TVideoState {
  activeVideoId: string | null;
  activeInstanceId: string | null;
  isPlaying: boolean;
  mode: TVideoMode;
}

export const useVideoStore = defineStore('video', {
  state: (): TVideoState => ({
    activeVideoId: null,
    activeInstanceId: null,
    isPlaying: false,
    mode: 'inline',
  }),

  actions: {
    playVideo(videoId: string, instanceId: string) {
      this.activeVideoId = videoId;
      this.activeInstanceId = instanceId;
      this.isPlaying = true;
    },
    pauseVideo(videoId: string, instanceId: string) {
      if (this.activeVideoId === videoId && this.activeInstanceId === instanceId) {
        this.isPlaying = false;
      }
    },
    setMode(mode: TVideoMode) {
      this.mode = mode;
    },
    reset() {
      this.activeVideoId = null;
      this.activeInstanceId = null;
      this.isPlaying = false;
      this.mode = 'inline';
    },
  },
});

export default useVideoStore;
